module.exports = __webpack_public_path__ + "static/media/icon-supplies-towel.624cf759.svg";